import ms from 'ms'

export const EXTENSION_BANNER_DISMISS_COOKIE = 'cf_studio_ext_banner_dismissed'
export const EXTENSION_BANNER_SUPPRESS_MS = ms('19d')
